import { ArrowDropDownOutlined, ArrowDropUpOutlined } from "@material-ui/icons";
import React from "react";

export default function DropDownArrow() {
  return (
    <div className='d-flex flex-column'>
      <ArrowDropUpOutlined style={{ fontSize: "14px", color: "#9EA0A5" }} />
      <ArrowDropDownOutlined style={{ fontSize: "14px", marginTop: "-6px", color: "#9EA0A5" }} />
    </div>
  );
}
